import { SpeechBubble, createStyles } from '@ingeniorforeningen/figurine-core';
import {
  getFormattedDateFromString,
  getFormattedDateTimeFromString,
} from '../../../helpers/casesHelpers';
import { AppLanguage, CaseMessage } from '../../../types';
import InfoMessage from '../InfoMessage';

const style = createStyles((theme) => ({
  root: {
    ul: {
      listStyleType: 'disc',
      listStylePosition: 'outside',
      '& ul': {
        listStyleType: 'circle',
        listStylePosition: 'outside',
        '& ul': {
          listStyleType: 'square',
          listStylePosition: 'outside',
          '& ul': {
            listStyleType: 'disc',
            listStylePosition: 'outside',
            '& ul': {
              listStyleType: 'circle',
              listStylePosition: 'outside',
              '& ul': {
                listStyleType: 'square',
                listStylePosition: 'outside',
                '& ul': {
                  listStyleType: 'disc',
                  listStylePosition: 'outside',
                  '& ul': {
                    listStyleType: 'circle',
                    listStylePosition: 'outside',
                    '& ul': {
                      listStyleType: 'square',
                      listStylePosition: 'outside',
                      '& ul': {
                        listStyleType: 'disc',
                        listStylePosition: 'outside',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    ol: {
      listStyleType: 'decimal',
      listStylePosition: 'outside',
      '& ol': {
        listStyleType: 'lower-alpha',
        listStylePosition: 'outside',
        '& ol': {
          listStyleType: 'lower-roman',
          listStylePosition: 'outside',
          '& ol': {
            listStyleType: 'decimal',
            listStylePosition: 'outside',
            '& ol': {
              listStyleType: 'lower-alpha',
              listStylePosition: 'outside',
              '& ol': {
                listStyleType: 'lower-roman',
                listStylePosition: 'outside',
                '& ol': {
                  listStyleType: 'decimal',
                  listStylePosition: 'outside',
                  '& ol': {
                    listStyleType: 'lower-alpha',
                    listStylePosition: 'outside',
                    '& ol': {
                      listStyleType: 'lower-roman',
                      listStylePosition: 'outside',
                      '& ol': {
                        listStyleType: 'decimal',
                        listStylePosition: 'outside',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}));

export type EventItem =
  | {
      id: string;
      timestamp: string;
      type: 'created' | 'closed';
    }
  | {
      id: string;
      timestamp: string;
      message: CaseMessage;
      type: 'message';
    };

type Props = {
  item: EventItem;
  language: AppLanguage;
  username?: string;
  eventCaseCreatedText: string;
  eventCaseClosedText: string;
  errorText: string;
};

export const RenderMessages = ({
  item,
  language,
  username,
  eventCaseCreatedText,
  eventCaseClosedText,
  errorText,
}: Props) => {
  const { classes } = style();
  const renderEventItem = (item: EventItem) => {
    switch (item.type) {
      case 'created':
        return (
          <InfoMessage
            text={eventCaseCreatedText}
            date={getFormattedDateTimeFromString(item.timestamp, language)}
            iconName="SquarePlus"
            cypress="caseCreated"
          />
        );
      case 'message': {
        const message = item.message;
        if (!message.noteText && message.documents.length === 0) {
          return null;
        }
        return (
          <SpeechBubble
            className={classes.root}
            outgoing={!message.author}
            author={message.author || username}
            creationDate={getFormattedDateTimeFromString(message.creationDate, language)}
            md={11}
            my="xl"
            text={`<span>${message.noteText}</span>`}
            posting={message.posting}
            error={message.error ? errorText : undefined}
            fileNames={message.documents.map((doc) => doc.fileName)}
            cypress="message"
            id="speechbubble"
          />
        );
      }
      case 'closed':
        return (
          <InfoMessage
            text={eventCaseClosedText}
            date={getFormattedDateFromString(item.timestamp, language)}
            iconName="SquareCheck"
            cypress="caseClosed"
          />
        );
      default:
        return null;
    }
  };

  return renderEventItem(item);
};
